const BASE = process.env.REACT_APP_BACKEND_URL;

async function parseJsonOrThrow(resp, fallbackMessage) {
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.error || fallbackMessage);
  }
  return resp.json();
}

export async function listQuestions({ themeName, organizationId, sessionId, token }) {
  const resp = await fetch(`${BASE}/listQuestions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ themename: themeName, organizationId, sessionId }),
  });
  const data = await parseJsonOrThrow(resp, "Failed to load crossroads");
  return { questions: data.questions || [], source: data.source || "own" };
}

/** Add or edit one crossroads; `question` carries every content field (see quizHelpers). */
export async function saveQuestion({ themeName, token, action, editId, question }) {
  const resp = await fetch(`${BASE}/saveQuestion`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ...question,
      themename: themeName,
      action,
      edit_id: editId || undefined,
    }),
  });
  return parseJsonOrThrow(resp, "Failed to save crossroads");
}

/** Persist the journey order: `ids` = every crossroads id, first to last. */
export async function reorderQuestions({ themeName, ids, token }) {
  const resp = await fetch(`${BASE}/reorderQuestions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ themename: themeName, ids }),
  });
  return parseJsonOrThrow(resp, "Failed to reorder crossroads");
}

export async function deleteQuestion({ themeName, id, token }) {
  const resp = await fetch(`${BASE}/deleteQuestion`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ themename: themeName, id }),
  });
  return parseJsonOrThrow(resp, "Failed to delete question");
}

export async function deleteAllQuestions({ themeName, token }) {
  const resp = await fetch(`${BASE}/deleteAllQuestions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ themename: themeName }),
  });
  return parseJsonOrThrow(resp, "Failed to delete all questions");
}

export async function importQuestionsCsv({ themeName, rows, token }) {
  const resp = await fetch(`${BASE}/importQuestionsCsv`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ themename: themeName, rows }),
  });
  return parseJsonOrThrow(resp, "Failed to import CSV");
}
